import Immutable from 'immutable';
import ActionTypes from '../ActionTypes';
import createReducer from '../../util/createReducer';

const initialState = Immutable.fromJS({
  windowHeight: 0,
  windowWidth: '',
  viewport: 'desktop',
});

export default createReducer(initialState, {
  [ActionTypes.Responsive.updateWindowWidth](state, { width }) {
    const viewport = width >= 800 ? 'desktop' : 'mobile';
    return state.set('windowWidth', width).set('viewport', viewport);
  },
  [ActionTypes.Responsive.updateWindowHeight](state, { height }) {
    return state.set('windowHeight', height);
  },
});



// WEBPACK FOOTER //
// /src/store/reducers/Responsive.js